// removed by extract-text-webpack-plugin
module.exports = {"CheckoutSummary":"_1xBm4j5hECL-q6sCIhiBB4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/CheckoutSummary/CheckoutSummary.css
// module id = 176
// module chunks = 0